import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import axios from 'axios';
import {BACKEND_SERVER} from './paths.js';

interface IpResponse {
    user_country: string;
    user_ip: string;
    connect_ip: string;
    connect_port: number;
    is_apple_test: boolean;
    client_json: string;
    metadata: boolean | null; // Puede ser `false` o un objeto dependiendo de tu lógica
    info: {
        status: string;
        country: string;
        countryCode: string;
        region: string;
        regionName: string;
        city: string;
        zip: string;
        lat: number;
        lon: number;
        timezone: string;
        isp: string;
        org: string;
        as: string;
        query: string;
    };
    version: string;
}

interface CountryResponse {
    country: string;
}

interface UserContextType {
    userIP: string;
    userCountry: string;
    userLoading: boolean;
}

interface UserProviderProps {
    children: ReactNode;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {


    const [userIP, setUserIP] = useState<string>('');
    const [userCountry, setUserCountry] = useState<string>('XX');
    const [userLoading, setUserLoading] = useState<boolean>(true);


    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const ipResponse = await axios.get<IpResponse>('https://launcher.legend.mu/api/cs');
                const userIp = ipResponse.data.user_ip;
                setUserIP(userIp);
                //const countryResponse = await axios.get(`${BACKEND_SERVER}/api/get_country?ip=${userIp}`);
                const userCountry = ipResponse.data.user_country.toUpperCase();
                //console.log(userCountry);
                setUserCountry(userCountry);
            } catch (error) {
                console.error('Error fetching user info:', error);
            } finally {
                setUserLoading(false);
            }
        };

        fetchUserInfo();
    }, []);

    return (
        <UserContext.Provider value={{ userIP: userIP, userCountry: userCountry, userLoading: userLoading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = (): UserContextType => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
